import { theme } from "@chakra-ui/core";
import merge from "lodash/merge";
import colors from "./components/utils/colors";

// Our theme overrides for Chakra.
export default merge(theme, {
  // This already includes the theme colors, so we don't have to
  // extend the existing color object.
  colors,
  fonts: {
    body: "GT America, serif",
    heading: "GT Super Text, serif",
  },
});
